/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfig } from './taskEvaluationConfig';

export type TaskCreateRequestEvaluation = TaskEvaluationConfig | null;
